export const CIQ_EVENTS_MODULE_ID = 'events-ciq-events-module';

export const LOAD_CIQ_EVENTS_MODULE = () => import('@capital-access/events/ciq-events').then(m => m.CiqEventsModule);
